/**
 * @flow
 * @relayHash 3e57b5c04d3144323b658a842b8f8c79
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ShopsReviews_queryResult$ref = any;
export type ReviewsSort = "highest_rating" | "lowest_rating" | "recent" | "%future added value";
export type VendorReviewsQueryInput = {
  vendor_id: number,
  sort?: ?ReviewsSort,
  page?: ?PageInfoInput,
};
export type PageInfoInput = {
  limit?: ?number,
  offset?: ?number,
};
export type ShopsReviewsQueryVariables = {|
  input?: ?VendorReviewsQueryInput
|};
export type ShopsReviewsQueryResponse = {|
  +$fragmentRefs: ShopsReviews_queryResult$ref
|};
export type ShopsReviewsQuery = {|
  variables: ShopsReviewsQueryVariables,
  response: ShopsReviewsQueryResponse,
|};
*/


/*
query ShopsReviewsQuery(
  $input: VendorReviewsQueryInput
) {
  ...ShopsReviews_queryResult_2VV6jB
}

fragment ShopsReviews_queryResult_2VV6jB on Query {
  vendor_reviews(input: $input) {
    related_sorts {
      display_name
      name
      selected
    }
    page_info {
      ...PaginationData_pageInfo
    }
    result {
      ref_id
      rating
      review
      purchased_on_ayk
      is_current_user
      user {
        first_name
        last_name
      }
      vendor {
        ref_id
        name
        avg_rating
        rating_count
        current_user_review {
          ref_id
          rating
          review
          id
        }
        id
      }
      id
    }
    errors {
      field
      messages
      code
    }
  }
}

fragment PaginationData_pageInfo on PageInfo {
  current_page
  items_count
  limit
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VendorReviewsQueryInput",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rating",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "review",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShopsReviewsQuery",
  "id": null,
  "text": "query ShopsReviewsQuery(\n  $input: VendorReviewsQueryInput\n) {\n  ...ShopsReviews_queryResult_2VV6jB\n}\n\nfragment ShopsReviews_queryResult_2VV6jB on Query {\n  vendor_reviews(input: $input) {\n    related_sorts {\n      display_name\n      name\n      selected\n    }\n    page_info {\n      ...PaginationData_pageInfo\n    }\n    result {\n      ref_id\n      rating\n      review\n      purchased_on_ayk\n      is_current_user\n      user {\n        first_name\n        last_name\n      }\n      vendor {\n        ref_id\n        name\n        avg_rating\n        rating_count\n        current_user_review {\n          ref_id\n          rating\n          review\n          id\n        }\n        id\n      }\n      id\n    }\n    errors {\n      field\n      messages\n      code\n    }\n  }\n}\n\nfragment PaginationData_pageInfo on PageInfo {\n  current_page\n  items_count\n  limit\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShopsReviewsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ShopsReviews_queryResult",
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopsReviewsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendor_reviews",
        "storageKey": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "VendorReviewsQueryInput"
          }
        ],
        "concreteType": "VendorReviewsQueryResult",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "related_sorts",
            "storageKey": null,
            "args": null,
            "concreteType": "SortOption",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "display_name",
                "args": null,
                "storageKey": null
              },
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "selected",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "page_info",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "current_page",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "items_count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "limit",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "result",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorReview",
            "plural": true,
            "selections": [
              v2,
              v3,
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "purchased_on_ayk",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_current_user",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "UserPublicInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "first_name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "last_name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Shop",
                "plural": false,
                "selections": [
                  v2,
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "avg_rating",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "rating_count",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "current_user_review",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorReview",
                    "plural": false,
                    "selections": [
                      v2,
                      v3,
                      v4,
                      v5
                    ]
                  },
                  v5
                ]
              },
              v5
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "errors",
            "storageKey": null,
            "args": null,
            "concreteType": "Error",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "field",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "messages",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '722ecb5f16136681421cad7131220fd7';
module.exports = node;
